export default {
  // 标签页
  fiatCurrencySummary: "法币汇总",
  virtualCurrencySummary: "虚拟币汇总",
  transactionDetails: "交易详情",

  // 下载
  downloadFileName: "数据明细",
};
